// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__rPYnr","checkbox":"Checkbox_checkbox__A6FOE","label":"Checkbox_label__Ky2C3","disabled":"Checkbox_disabled__yr+4s"};